<template>
  <v-footer class="flex primary" dark padless>
    <v-row justify="center" no-gutters class="pa-1">
      <v-col cols="12 text-center">
        <a
          href="https://github.com/Manerr/AMCaf"
          class="ml-2 mr-2 white--text"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-icon size="24px">mdi-github</v-icon>
        </a>
        <span class="body-1">Antonin Huaut</span>
      </v-col>
    </v-row>
  </v-footer>
</template>-

<script>
export default {
  data: () => ({})
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>